/* eslint-disable */
<template>
  <div class="login p-0">
    <div class="red-vertical"></div>
    <div class="login-container">
      <div class="login-left">
        <div class="logo">
          <img src="@/assets/images/red_health_logo.svg"/>
        </div>
        <v-form ref="form" class="login-form">
          <v-subheader>Business Email Address</v-subheader>
          <v-text-field v-model="account.userName" :rules="[rules.validateUsername.required]"
                        placeholder="Enter your Email Address" solo required></v-text-field>

          <v-subheader>Password</v-subheader>
          <v-text-field
              v-model="account.password"
              :type="showPassword ? 'text' : 'password'"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.validatePassword.required]"
              placeholder="Enter your Password"
              @click:append="() => (showPassword = !showPassword)"
              solo
              required
          ></v-text-field>

          <!-- <v-subheader>One Time Code</v-subheader>
          <v-text-field v-model="account.oneTime" placeholder="Enter Code from authenticator application " solo></v-text-field> -->

          <br/>
          <div class="alert alert-danger hidden-element">
            <a class="close" title="close">×</a>
            <b>Error:</b> {{ errorMessage }}
          </div>

          <div class="login-button">
            <v-btn class="red-button" dark @click="login">Login</v-btn>
          </div>
          <QRCodeModal ref="qrcodeModal" :codeProps="secretCode"/>
        </v-form>
        <div class="login-option">
          <div class="login-forgot">
            <router-link :to="{ name: 'forgot-password' }" class="text-decoration">Forgot Password?</router-link>
          </div>
          <a target="_blank"
             href="https://redhealth.com.au/red-health-online/red-health-online-how-to-create-a-new-account-and-set-up-2fa/"
             download="How to create new account.pdf" class="mt-4 text-decoration"
             style="display: block; color: #808080; font-size: 12px">Guide to logging in for the first time</a>
          <div class="login-enquire">Don’t have an account with Red Health Online? <a href="/enquiry"
                                                                                      class="text-decoration">Enquire
            Now</a></div>
        </div>
      </div>
      <SetNewPasswordModal ref="setNewPasswordModal"/>
      <el-dialog title="Select Specialist"
                 :visible.sync="showSelectModal"
                 @close="cancelDialog">
        <el-select v-model="selectedSp">
          <el-option v-for="item in specialists" :value="item.SpecialistID" :key="item.SpecialistID"
                     :label="getSpName(item)">{{ getSpName(item) }}
          </el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
    <v-btn class="white-button me-2" dark @click="showSelectModal = false">Cancel</v-btn>
    <v-btn dark :loading="loading" @click="submitForm('ruleForm')">Save</v-btn>
  </span>
      </el-dialog>
      <OTPModal ref="otpModal"/>
      <div class="login-right">
        <div class="banner">
          <a class="img" target="_blank" :href="src">
            <img src=""/>
          </a>
        </div>
      </div>
    </div>
    <Footer/>
  </div>
</template>

<script>
import auth from '@/assets/js/cognitoAuth'
import utilities from '@/assets/js/utilities'
import { touchLastActivityAt } from '@/assets/js/idleMonitor'
import Footer from '@/components/Footer'
import QRCodeModal from '@/components/QRCodeModal'
import SetNewPasswordModal from '@/components/SetNewPasswordModal'
import OTPModal from '@/components/OTPModal'
import * as imageCache from "vue";

export default {
  name: 'Login',
  props: ['messageProps'],
  components: {
    Footer,
    QRCodeModal,
    SetNewPasswordModal,
    OTPModal,
  },
  data() {
    return {
      loading: false,
      selectedSp: null,
      specialists: [],
      showSelectModal: false,
      showPassword: false,
      errorMessage: '',
      src: '',
      userToSave: null,
      account: {
        userName: '',
        password: '',
        oneTime: '',
      },
      secretCode: '',

      rules: {
        validateUsername: {
          required: (value) => !!value || 'Username is required.',
        },
        validatePassword: {
          required: (value) => !!value || 'Password is required.',
        },
      },

      verifyOtp: false,
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    getSpName(i) {
      return utilities.getSpecialistFullNameUpper(i)
    },
    cancelDialog() {
      this.showSelectModal = false
    },
    // Used on OTPModal
    setLastLoginDate(user) {
      var params = {
        UserID: user.id,
        Username: user.name,
        LastLoggedInDate: moment().format('YYYY-MM-DD HH:mm:ss'),
        SingleUserID: user.id,
      }
      var callback = (response) => {
      }
      return utilities.putLoginTime(params, callback)
    },

    async login() {
      // const canLogin = ['liuyuntian@shinetechsoftware.com','condylu@test.com','liuyuntian110@126.com','zhouxinhao@shinetechsoftware.com', 'mark@redhealth.com.au', 'gordana@westendmedical.com.au', 'qateam@redhealth.com.au', 'rh2uat@redhealth.com.au', 'marktest@redhealth.com.au', 'marktestclient@redhealth.com.au']
      // if(!canLogin.includes(this.account.userName.trim())) {
      //   this.$alert("We’re currently performing scheduled maintenance, to bring some exciting changes to Red Health Online.\n" +
      //       "\n" +
      //       "You’ll be able to login as normal from Monday, Thanks for your understanding.", 'Please note:', {
      //     confirmButtonText: 'Ok',
      //   });
      //   return false
      // }
      if (!this.$refs.form.validate()) {
        return false
      }

      this.$store.dispatch('loading/setLoadComponent', true)
      var authenticationData = {
        Username: this.account.userName.trim(),
        Password: this.account.password.trim(),
      }
      auth.login(authenticationData).then(async (user) => {
        this.$store.dispatch('loading/setLoadComponent', false)
        if (user != false && user != null && user !== undefined) {
          if (user.challengeName == 'NEW_PASSWORD_REQUIRED') {
            // User requires new password
            this.$refs.setNewPasswordModal.user = user
            this.$refs.setNewPasswordModal.handleModal()
          } else if (user.challengeName == 'MFA_SETUP') {
            await this.mfaSetup(user)
          } else if (user.challengeName == 'SOFTWARE_TOKEN_MFA') {
            this.promptForTotp(user)
          } else {
            var authentication = utilities.loadAuthentication(user.signInUserSession)
            await this.$store.dispatch('user/setAuthentication', authentication)
            touchLastActivityAt()

            let userToSave = await utilities.getUserBySub(user.signInUserSession.accessToken.payload['sub'])
            this.userToSave = userToSave
            if (userToSave) {
              // Zoho Integration
              // fetch('https://vtjfl2u95a.execute-api.ap-southeast-2.amazonaws.com/RHOReferenceData/zoho-login').then((response) => console.log(response))
              await this.$store.dispatch('user/setUser', userToSave)
              if (userToSave.type === 7) {
                const res = await utilities.getPracticeManagerProfile()
                const specialists = res.Specialists
                if (specialists.find(item => item.PracticeManagerSpecialist.Selected)) {
                  let result = await this.setLastLoginDate(userToSave)
                  if (result) this.redirectToHome()
                  return
                } else {
                  this.specialists = specialists
                  this.showSelectModal = true
                  return
                }
              }
              let result = await this.setLastLoginDate(userToSave)
              if (result) this.redirectToHome()
            }
          }
        }
      })
          .catch((error) => {
            this.$store.dispatch('loading/setLoadComponent', false)
            this.errorMessage = error.message
            utilities.showAlert('.alert-danger')
          })
    },
    async submitForm() {
      this.loading = true
      await utilities.putPracticeManagerProfile(this.selectedSp)
      await this.$store.dispatch('user/setUser', {
        ...this.userToSave,
        specialistId: this.selectedSp,
        list: this.specialists
      })
      this.loading = false
      await this.$store.dispatch('loading/setLoadComponent', true)
      let result = await this.setLastLoginDate(this.userToSave)
      await this.$store.dispatch('loading/setLoadComponent', false)
      if (result) this.redirectToHome()

    },
    async mfaSetup(user) {
      this.account.password = ""
      var code = await auth.addToAuthenticator(user)
      // Show email user name in authenticator app
      this.secretCode = 'otpauth://totp/RedHealthOnline:' + this.account.userName + '?secret=' + code + '&issuer=RedHealthOnline'
      this.$refs.qrcodeModal.user = user
      this.$refs.qrcodeModal.handleModal()

      setTimeout(() => {
        $(".qr-code-modal input[type='password']").focus()
        $(".qr-code-modal input[type='password']").on('keypress', (e) => {
          if (e.keyCode == 13) {
            this.$refs.qrcodeModal.clickSave()
          }
        })
      }, 500)
    },

    // Used on OTPModal
    redirectToHome() {
      const user = _.cloneDeep(this.$store.getters['user/getUser'])
      const mobile = user.mobile ? atob(user.mobile) : ''
      if (mobile === utilities.DEFAULT_MOBILE) {
        this.$router.push({name: 'edit-profile'}).catch((err) => {
        })
        this.$notify({
          dangerouslyUseHTMLString: true,
          message: '<div class="alert-success">' +
              '            <b>Warning:</b> Please update your mobile number' +
              '          </div>',
        });
      } else {
        if (this.$route.query.redirect) {
          this.$router.push(this.$route.query.redirect)
        } else {
          this.$router.push({name: 'home'}).catch((err) => {
          })
        }
      }
    },

    promptForTotp(user) {
      this.$refs.otpModal.user = user
      this.$refs.otpModal.handleModal()

      setTimeout(() => {
        $(".otp-modal input[type='password']").focus()
        $(".otp-modal input[type='password']").on('keypress', (e) => {
          if (e.keyCode == 13) {
            this.$refs.otpModal.clickSave()
          }
        })
      }, 500)
    }
  },
  async beforeMount() {
    // await auth.signOut()
    utilities.clearStore()
    this.$store.dispatch('user/setAuthentication', utilities.initAuthentication())
    utilities.getCurrentLocation()
    const { HeroImagePresignURL, HeroJumpLinkURL } = await utilities.getBannerImage()
    this.src = HeroJumpLinkURL
    $('.banner img').attr('src', HeroImagePresignURL)
    if (this.messageProps != undefined) {
      utilities.showSuccessMessage(this.messageProps)
    }
  },
  async mounted() {
    // Clear all sessions
    $('.login form').on('keypress', (e) => {
      if (e.keyCode == 13) {
        this.login()
      }
    })
  },
}
</script>
